import { useQuery } from "@tanstack/react-query";
import { UseQueryExtendedOptions, useQueryHandler } from "@rentablo/api";
import { FeedItemList, RentabloBlogFeed } from "@api/v1/model";
import { getNewsFeed, getNewsFeedRentabloBlog } from "@api/v1/methods";
import { GET_NEWS_FEED, GET_NEWS_FEED_RENTABLO_BLOG } from "../../cacheKeys";

interface Params {
  isin: string;
}

export const useGetNewsFeed = ({ isin }: Params) =>
  useQuery({
    queryKey: [GET_NEWS_FEED, isin],
    queryFn: () => getNewsFeed({ isin }),
  });

export const useGetNewsFeedRentabloBlog = (
  params: RentabloBlogFeed,
  options?: UseQueryExtendedOptions<
    FeedItemList,
    AxiosApiError,
    FeedItemList,
    (string | RentabloBlogFeed)[]
  >
) =>
  useQueryHandler({
    query: useQuery({
      queryKey: [GET_NEWS_FEED_RENTABLO_BLOG, params],
      queryFn: () => getNewsFeedRentabloBlog(params),
      ...options,
    }),
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });
